import { AlgorithmConfig, Task } from "@/features/login/types";
import { create } from "zustand";

interface AlgorithmState {
  tasks: Task[];
  taskTotal: number;
  configs: Record<string, AlgorithmConfig>; // keyed by taskId
  setTasks: (tasks: Task[], total: number) => void;
  setConfig: (taskId: string, config: AlgorithmConfig) => void;
  clearAll: () => void;
}

export const useAlgorithmStore = create<AlgorithmState>((set) => ({
  tasks: [],
  taskTotal: 0,
  configs: {},

  setTasks: (tasks, total) => set({ tasks, taskTotal: total }),

  setConfig: (taskId, config) =>
    set((state) => ({
      configs: { ...state.configs, [taskId]: config },
    })),

  clearAll: () => set({ tasks: [], taskTotal: 0, configs: {} }),
}));
